import { Injectable, Injector } from "@angular/core";
import { environment } from "@environments/environment";
import { Service } from "@services/service";

@Injectable()
export class ProjectService extends Service {
	constructor(injector: Injector) {
		super("Project", injector);
	}

	// API
	getProjectsByClient(id: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/GetProjectsByClient/${id}`);
	}

	markComplete(id: number) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/MarkComplete/${id}`, {});
	}
}